var EHDI = EHDI || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.ShapeManager = function() { 
    var _shape = [];
    
    var _this = this;
    var _shapeValues = _this.chooseShape();
    var _width = _shapeValues.width;
    var _height = _shapeValues.height;
    var _selectedBox = null;
    var _count = 0;
    var _types = ["box_blue", "box_green", "box_orange", "box_red", "box_violet", "box_yellow"];
    var _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
    var _combo = 1;
    var _armature = null;
    var _armatureName = _shapeValues.armatureName;
    var _ccwRot = _shapeValues.cwArr;
    var _cwRot = _shapeValues.ccwArr;
    var _rotCount = 0;
    var _animSprite;
    var _animationSprite;
    var _isAnimating = false;
    var _progression = 2;
    var _roundCount = 0;
    var _disableInput = false;

    var _noMoreMatchNotif = null;
    
    var _animTimeline = new TimelineMax();
    
    EHDI.aka.Container.call(this);
    var _displayContainer = new EHDI.aka.Container();
    this.addChild(_displayContainer);
    
    var _boxContainer = new EHDI.aka.Container();
    
    EHDI.GAME.pauseButton.timelineArray.push(_animTimeline); 
    
    _displayContainer.addChild(_boxContainer);
    
    _boxContainer.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.75);
    
    var shuffleBoxes = function() {
        var activeNodes = [];
        
        for(var i = 0; i < _shape.length; i++) {
            for (var j = 0; j < _shape[i].length; j++) {
                for (var k = 0; k < _shape[i][j].length; k++) {
                    if(_shape[i][j][k]) {
                        activeNodes.push({ x : _shape[i][j][k].indexX, y : _shape[i][j][k].indexY, z : _shape[i][j][k].indexZ});    
                    }
                }
            }
        }
        
        _boxContainer.destroy({children : true});
        createShape();
        _boxContainer = new EHDI.aka.Container();
        _boxContainer.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.75);
        _displayContainer.addChild(_boxContainer);
        _count = activeNodes.length;
        while(activeNodes.length > 0) {
            _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
            var progressionValue = Math.min(parseInt(_progression), 9) + 1;
            
            var randomValue = Math.floor(EHDI.NumberUtil.randomRange(1, progressionValue));
            var shapePosition = activeNodes.splice(Math.floor(EHDI.NumberUtil.randomRange(0, activeNodes.length)), 1)[0];
            var tempBox; 
            
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
            shapePosition = activeNodes.splice(Math.floor(EHDI.NumberUtil.randomRange(0, activeNodes.length)), 1)[0];
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            
        }
        
        
        repositionArtifacts();
        sortArtifactsLayering();
    }
    
    this.shuffle = function(autoShuffle) {
        if(_selectedBox)
            _selectedBox.deselect();
        _selectedBox = null;
        if(!autoShuffle) {
            EHDI.GAME.pauseButton.systemPause();
            EHDI.GAME.gameScene.leftArrow.visible = false;
            EHDI.GAME.gameScene.rightArrow.visible = false;
        }
        _animationSprite.alpha = 1;
        _displayContainer.alpha = 0;
       
        do {
            shuffleBoxes();
        } while(!checkForPairs())
        
        _animTimeline.clear();
        _animTimeline.to(_animationSprite, 0.25, {alpha : 0}, "+=0.75");
        _animTimeline.to(_displayContainer, 0.25, {alpha : 1});
        _animTimeline.addCallback(function() {
            if(!autoShuffle) {
                EHDI.GAME.pauseButton.systemUnpause();
                EHDI.GAME.gameScene.leftArrow.visible = true;
                EHDI.GAME.gameScene.rightArrow.visible = true;
            }
            if(_noMoreMatchNotif) {
                _noMoreMatchNotif.hideMe();
                _noMoreMatchNotif = null;
            }
        }); 
    }
    
    var isUnclickable = function(box, indexX, indexZ) {
        if ((indexX - 1 >= 0 && _shape[box.indexY][indexX - 1][indexZ] && indexX + 1 < _shape[box.indexY].length && _shape[box.indexY][indexX + 1][indexZ]) || (indexZ - 1 >= 0 && _shape[box.indexY][indexX][indexZ - 1] && indexZ + 1 < _shape[box.indexY][indexX].length && _shape[box.indexY][indexX][indexZ + 1]))
            return true;
        else
            return false;
    }
    
    var checkForPairs = function() {
        var clickable = [];
        
        for(var i = 0; i < _shape.length; i++) {
            for (var j = 0; j < _shape[i].length; j++) {
                for (var k = 0; k < _shape[i][j].length; k++) {
                    if(_shape[i][j][k] && !isUnclickable(_shape[i][j][k], _shape[i][j][k].indexX, _shape[i][j][k].indexZ))
                        clickable.push(_shape[i][j][k]);    
                }
            }
        }
        
        for(var i = 0; i < clickable.length; i++) {
            for(var j = i + 1; j < clickable.length; j++) {
                if(clickable[i].artifactType == clickable[j].artifactType)
                    return true;
            }
        }
        return false;
    }
    
    var onCheckIfComplete = function() {
        if(!EHDI.GAME.gameScene.hasShuffled)
            EHDI.GAME.gameScene.shuffleButton.visible = true;
        EHDI.GAME.gameScene.leftArrow.visible = true;
        EHDI.GAME.gameScene.rightArrow.visible = true;
        _isAnimating = false;
        _animTimeline.clear();
        _animTimeline.to(_animationSprite, 0.1, {alpha : 0});
        _animTimeline.to(_boxContainer, 0.1, {alpha : 1}, "-=0.1");
    }
    
    var createAnimation = function() {
        if(_animationSprite) {
            _animationSprite.textures = _cwRot[0];
            _animationSprite.gotoAndStop(0);
        }
        _animationSprite=  new EHDI.aka.AnimatedSprite(_ccwRot[0], false);
        _animationSprite.anchor.set(0.5);
        _animationSprite.loop = false;
        _animationSprite.stop();
        _animationSprite.alpha = 0;
        _animationSprite.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.75);
        _animationSprite.position.y -= _animationSprite.height * _shapeValues.armatureOffsetY;
        _this.addChild(_animationSprite);
        _animationSprite.onComplete = onCheckIfComplete;
        _animationSprite.animationSpeed = 0.01;
    }
    
    var animationUpdate = function(dt) {
        if(_animationSprite && _animationSprite.playing)
            _animationSprite.update(dt);
    }
    
    var createArmature = function() {
        _armature = EHDI.DBoneFactory.createArmature(_armatureName);
        _animSprite = _armature.getDisplay();
        dragonBones.WorldClock.clock.add(_armature);
        _animSprite.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.75);
        _animSprite.position.y -= _animSprite.height * _shapeValues.armatureOffsetY;
        _animSprite.position.x += _animSprite.width * _shapeValues.armatureOffsetX;
        _this.addChild(_animSprite);
        _animSprite.alpha = 0;
        _armature.addEventListener(dragonBones.AnimationEvent.COMPLETE, function() { 
            if(!EHDI.GAME.gameScene.hasShuffled)
                EHDI.GAME.gameScene.shuffleButton.visible = true;
            EHDI.GAME.gameScene.leftArrow.visible = true;
            EHDI.GAME.gameScene.rightArrow.visible = true;
            _isAnimating = false;
            _animTimeline.clear();
            _animTimeline.to(_animSprite, 0.1, {alpha : 0});
            _animTimeline.to(_boxContainer, 0.1, {alpha : 1}, "-=0.1");
        });
    }
    
    var afterAnimation = function() {
        _disableInput = false;
        if(_count <= 0) {
            EHDI.GAME.bgm.stop();
            _roundCount++;
            EHDI.GAME.pauseButton.isPaused = true;
            if(EHDI.GAME.constants.gameLevelComplete) {
                EHDI.GAME.constants.gameLevelComplete(EHDI.GAME.constants.gameName, EHDI.GAME.gameScene.scoreHolder.getScore());   
            }
            EHDI.GAME.gameScene.addChild(new EHDI.components.roundClearedNotif(_roundCount));
//            EHDI.GAME.gameScene.scoreHolder.addSparkles();
            _progression++;
            EHDI.GAME.gameScene.hasShuffled = false;
            _rotCount = 0;
            _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
            _shape = [];
            _shapeValues = _this.chooseShape();
            _width = _shapeValues.width;
            _height = _shapeValues.height;
            _boxContainer.destroy({children : true});
            _boxContainer = new EHDI.aka.Container();
            _displayContainer.addChild(_boxContainer)
            createShape();
            _armatureName = _shapeValues.armatureName;
            _ccwRot = _shapeValues.ccwArr;
            _cwRot = _shapeValues.cwArr;
//            createArmature();
            createAnimation();
            randomizeArtifacts();
            repositionArtifacts();
            sortArtifactsLayering();
            _boxContainer.position.set(EHDI.screen.stageWidth * 0.5, EHDI.screen.stageHeight * 0.75);
            if(!EHDI.GAME.gameScene.hasShuffled)
                EHDI.GAME.gameScene.shuffleButton.visible = true;
        } else {
            if(!checkForPairs()) {
                EHDI.GAME.pauseButton.isPaused = true;
                _noMoreMatchNotif = new EHDI.components.noMoreMatchNotif();
                EHDI.GAME.gameScene.addChild(_noMoreMatchNotif);
                _this.shuffle(true);
            }
        }
    }
    
    var processSelection = function(box) {
        //process if outside
        //shake if inside
        if(_disableInput)
            return;
        
        var indexX = box.indexX;
        var indexZ = box.indexZ;
        
        if(isUnclickable(box, indexX, indexZ)) {
            _disableInput = true;
            box.shake(function() {
                _disableInput = false;
            });
            return;
        }
        
        if(_selectedBox === box) {  
            _selectedBox.deselect();
            _selectedBox = null;
        } else if(_selectedBox === null) {
            _selectedBox = box;
            _selectedBox.select();
            EHDI.GAME.soundManager.playSFX("select");
        } else {
            _disableInput = true;
            if(_selectedBox.artifactType === box.artifactType) {
                _selectedBox.correct(afterAnimation);
                box.correct();
                EHDI.GAME.soundManager.playSFX("correct");
                EHDI.GAME.gameScene.scoreHolder.addScore(2 * _combo);
                _combo++;
                _shape[box.indexY][box.indexX][box.indexZ] = null;
                _shape[_selectedBox.indexY][_selectedBox.indexX][_selectedBox.indexZ] = null;
                _selectedBox = null;
                _count-=2;
            } else {
                _selectedBox.incorrect();
                box.incorrect(function() {
                    _disableInput = false;
                    box.select();
                });
                EHDI.GAME.soundManager.playSFX("wrong");
                _selectedBox = box;
                _combo = 1;
            }
        }
    }
    
    var createShape = function() {
        for(var y = 0; y < _height; y++) {
            var yAxis = [];
            for(var x = 0; x < _width; x++) {
                var xAxis = [];
                for(var z = 0; z < _width; z++) {
                    var zAxis = null;
                    xAxis.push(zAxis);
                }
                yAxis.push(xAxis);
            } 
            _shape.push(yAxis);
        }
    }
    
    var randomizeArtifacts = function() {
        _count = _shapeValues.values.length;
        while(_shapeValues.values.length > 0) {
            _curType = _types[Math.floor(EHDI.NumberUtil.randomRange(0, _types.length))];
            
            var progressionValue = Math.min(parseInt(_progression), 9) + 1;
            
            var randomValue = Math.floor(EHDI.NumberUtil.randomRange(1, progressionValue));
            var shapePosition = _shapeValues.values.splice(Math.floor(EHDI.NumberUtil.randomRange(0, _shapeValues.values.length)), 1)[0];
//            var shapePosition = _shapeValues.values.splice(0, 1)[0];
            var tempBox; 
            
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
//            var shapePosition = _shapeValues.values.splice(0, 1)[0];
            shapePosition = _shapeValues.values.splice(Math.floor(EHDI.NumberUtil.randomRange(0, _shapeValues.values.length)), 1)[0];
            tempBox = new EHDI.components.MatchBox(_curType, randomValue, processSelection);
            tempBox.indexX = shapePosition.x;
            tempBox.indexY = shapePosition.y;
            tempBox.indexZ = shapePosition.z;
            _shape[shapePosition.y][shapePosition.x][shapePosition.z] = tempBox;
            _boxContainer.addChild(tempBox);
            
        }
        
    }
    
    var repositionArtifacts = function() {
        for(var y = 0; y < _height; y++) {
            for(var x = 0; x < _width; x++) {
                for(var z = 0; z < _width; z++) {
                    if(_shape[y][x][z]) {
                        _shape[y][x][z].position.set(-x * _shape[y][x][z].width * 0.5 + z * _shape[y][x][z].width * 0.5, -y * _shape[y][x][z].height * 0.684 + z * _shape[y][x][z].height * 0.18 + x * _shape[y][x][z].height * 0.18);
                    }
                }
            }
        }
    }
    
    var sortArtifactsLayering = function() {
        _boxContainer.children.sort(function(a,b) {
            return a.indexZ - b.indexZ || a.indexX - b.indexX || a.indexY - b.indexY;
        })
    }
    
    var rotateCW = function(arr) {
        var temp = [];
        for (var i = 0; i < arr.length; ++i) {
            var row = [];
            for (var j = 0; j < arr[i].length; ++j) {
                row.push(arr[j][arr[i].length - i - 1]);
                if(arr[j][arr[i].length - i - 1]) {
                    arr[j][arr[i].length - i - 1].indexX = i;
                    arr[j][arr[i].length - i - 1].indexZ = j;
                }
            }
            temp.push(row);
        }
        return temp;
    }
    
    var rotateCCW = function(arr) {
        var temp = [];
        for (var i = 0; i < arr.length; ++i) {
            var row = [];
            for (var j = 0; j < arr[i].length; ++j) {
                row.push(arr[arr.length - j - 1][i]);
                if(arr[arr.length - j - 1][i]) {
                    arr[arr.length - j - 1][i].indexX = i;
                    arr[arr.length - j - 1][i].indexZ = j;
                }
            }
            temp.push(row);
        }
        return temp;
    }
    
    this.rotateAllCCW = function() {
        if(_isAnimating)
            return;
        EHDI.GAME.gameScene.leftArrow.visible = false;
        EHDI.GAME.gameScene.rightArrow.visible = false;
        EHDI.GAME.soundManager.playSFX("button_sfx");
        _isAnimating = true;
        EHDI.GAME.gameScene.shuffleButton.visible = false;
        _animTimeline.clear();
        _animTimeline.to(_animationSprite, 0.1, {alpha : 1});
        _animTimeline.to(_boxContainer, 0.1, {alpha : 0}, "-=0.1");
        _animTimeline.addCallback(function() {
            _animationSprite.textures = _ccwRot[_rotCount];
            _animationSprite.gotoAndPlay(0);
//            _armature.animation.gotoAndPlay(_armature.animation.animationList[_ccwRot[_rotCount]], -1, -1, 1);
            
            for(var i = 0; i < _shape.length; i++) {
                _shape[i] = rotateCCW(_shape[i]);
            }
            repositionArtifacts();
            sortArtifactsLayering();
            _rotCount++;
            if(_rotCount >= _ccwRot.length)
                _rotCount = 0;
        });
        
        
    }
    
    this.rotateAllCW = function() {
        if(_isAnimating)
            return;
        
        EHDI.GAME.gameScene.leftArrow.visible = false;
        EHDI.GAME.gameScene.rightArrow.visible = false;
        EHDI.GAME.soundManager.playSFX("button_sfx");
        EHDI.GAME.gameScene.shuffleButton.visible = false;
        _isAnimating = true;
        _animTimeline.clear();
        _animTimeline.to(_animationSprite, 0.1, {alpha : 1});
        _animTimeline.to(_boxContainer, 0.1, {alpha : 0}, "-=0.1");
        _animTimeline.addCallback(function() {
            _animationSprite.textures = _cwRot[_rotCount];
            _animationSprite.gotoAndPlay(0);
//            _armature.animation.gotoAndPlay(_armature.animation.animationList[_cwRot[_rotCount]], -1, -1, 1);
            for(var i = 0; i < _shape.length; i++) {
               _shape[i] =  rotateCW(_shape[i]);
            }
            repositionArtifacts();
            sortArtifactsLayering();
            _rotCount--;
            if(_rotCount < 0)
                _rotCount = _cwRot.length - 1;
        });
    }
    
    createShape();
    randomizeArtifacts();
    repositionArtifacts();
    sortArtifactsLayering();
//    createArmature();
    createAnimation();
    EHDI.GAME.updateManager.addFrameListener(animationUpdate);
}

EHDI.components.ShapeManager.prototype = Object.create(EHDI.aka.Container.prototype);


EHDI.components.ShapeManager.prototype.chooseShape = function() {
    var smallCube = {
        width : 5,
        height : 4,
        armatureName : "rotate_3x3cube",
        ccwArr : [[EHDI.Assets.images["rotate_cube3_01"], EHDI.Assets.images["rotate_cube3_02"], EHDI.Assets.images["rotate_cube3_03"], EHDI.Assets.images["rotate_cube3_04"], EHDI.Assets.images["rotate_cube3_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_cube3_01"], EHDI.Assets.images["rotate_cube3_04"], EHDI.Assets.images["rotate_cube3_03"], EHDI.Assets.images["rotate_cube3_02"], EHDI.Assets.images["rotate_cube3_01"]]],
        armatureOffsetX : 0,
        armatureOffsetY : 0.18,
        values : [
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 1, y : 0, z : 3},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 0, y : 1, z : 0},
            {x : 0, y : 1, z : 1},
            {x : 0, y : 1, z : 2},
            {x : 0, y : 1, z : 3},
            {x : 0, y : 1, z : 4},
            {x : 1, y : 1, z : 0},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 1, y : 1, z : 4},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 2, y : 1, z : 4},
            {x : 3, y : 1, z : 0},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 3, y : 1, z : 4},
            {x : 4, y : 1, z : 0},
            {x : 4, y : 1, z : 1},
            {x : 4, y : 1, z : 2},
            {x : 4, y : 1, z : 3},
            {x : 4, y : 1, z : 4},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 2, y : 3, z : 2}
        ]
    }
    
    var largeCube = {
        width : 4,
        height : 4,
        armatureName : "rotate_4x4cube",
        ccwArr : [[EHDI.Assets.images["rotate_cube4_01"], EHDI.Assets.images["rotate_cube4_02"], EHDI.Assets.images["rotate_cube4_03"], EHDI.Assets.images["rotate_cube4_04"], EHDI.Assets.images["rotate_cube4_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_cube4_01"], EHDI.Assets.images["rotate_cube4_04"], EHDI.Assets.images["rotate_cube4_03"], EHDI.Assets.images["rotate_cube4_02"], EHDI.Assets.images["rotate_cube4_01"]]],
        armatureOffsetX : 0,
        armatureOffsetY : 0.235,
        values: [
            {x : 0, y : 0, z : 1},
            {x : 0, y : 0, z : 2},
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 3},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 3},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 0, y : 1, z : 0},
            {x : 0, y : 1, z : 1},
            {x : 0, y : 1, z : 2},
            {x : 0, y : 1, z : 3},
            {x : 1, y : 1, z : 0},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 0},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 0, y : 2, z : 0},
            {x : 0, y : 2, z : 1},
            {x : 0, y : 2, z : 2},
            {x : 0, y : 2, z : 3},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 0, y : 3, z : 1},
            {x : 0, y : 3, z : 2},
            {x : 1, y : 3, z : 0},
            {x : 1, y : 3, z : 3},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 3},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 2},
        ]
    }
    
    var cross = {
        width : 4,
        height : 5,
        armatureName : "rotate_cross",
        ccwArr : [[EHDI.Assets.images["rotate_cross_01"], EHDI.Assets.images["rotate_cross_02"], EHDI.Assets.images["rotate_cross_03"], EHDI.Assets.images["rotate_cross_04"], EHDI.Assets.images["rotate_cross_05"]], [EHDI.Assets.images["rotate_cross_05"], EHDI.Assets.images["rotate_cross_06"], EHDI.Assets.images["rotate_cross_07"], EHDI.Assets.images["rotate_cross_08"], EHDI.Assets.images["rotate_cross_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_cross_01"], EHDI.Assets.images["rotate_cross_08"], EHDI.Assets.images["rotate_cross_07"], EHDI.Assets.images["rotate_cross_06"], EHDI.Assets.images["rotate_cross_05"]], [EHDI.Assets.images["rotate_cross_05"], EHDI.Assets.images["rotate_cross_04"], EHDI.Assets.images["rotate_cross_03"], EHDI.Assets.images["rotate_cross_02"], EHDI.Assets.images["rotate_cross_01"]]],
        armatureOffsetX : 0.16,
        armatureOffsetY : 0.31,
        values: [
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 1, y : 3, z : 0},
            {x : 1, y : 3, z : 1},
            {x : 1, y : 3, z : 2},
            {x : 1, y : 3, z : 3},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 1, y : 4, z : 1},
            {x : 1, y : 4, z : 2},
            {x : 2, y : 4, z : 1},
            {x : 2, y : 4, z : 2},
        ]
    }
    
    var pyramid = {
        width : 5,
        height : 4,
        armatureName : "rotate_pyramid",
        ccwArr : [[EHDI.Assets.images["rotate_pyramid_01"], EHDI.Assets.images["rotate_pyramid_02"], EHDI.Assets.images["rotate_pyramid_03"], EHDI.Assets.images["rotate_pyramid_04"], EHDI.Assets.images["rotate_pyramid_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_pyramid_01"], EHDI.Assets.images["rotate_pyramid_04"], EHDI.Assets.images["rotate_pyramid_03"], EHDI.Assets.images["rotate_pyramid_02"], EHDI.Assets.images["rotate_pyramid_01"]]],
        armatureOffsetX : 0,
        armatureOffsetY : 0.12,
        values: [
            {x : 0, y : 0, z : 0},
            {x : 0, y : 0, z : 1},
            {x : 0, y : 0, z : 2},
            {x : 0, y : 0, z : 3},
            {x : 0, y : 0, z : 4},
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 1, y : 0, z : 3},
            {x : 1, y : 0, z : 4},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 2, y : 0, z : 4},
            {x : 3, y : 0, z : 0},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 3, y : 0, z : 4},
            {x : 4, y : 0, z : 0},
            {x : 4, y : 0, z : 1},
            {x : 4, y : 0, z : 2},
            {x : 4, y : 0, z : 3},
            {x : 4, y : 0, z : 4},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 2, y : 3, z : 2},
        ]
    }
    
    var house = {
        width : 5,
        height : 5,
        armatureName : "rotate_tablet",
        ccwArr : [[EHDI.Assets.images["rotate_tablet_01"], EHDI.Assets.images["rotate_tablet_02"], EHDI.Assets.images["rotate_tablet_03"], EHDI.Assets.images["rotate_tablet_04"], EHDI.Assets.images["rotate_tablet_05"]], [EHDI.Assets.images["rotate_tablet_05"], EHDI.Assets.images["rotate_tablet_06"], EHDI.Assets.images["rotate_tablet_07"], EHDI.Assets.images["rotate_tablet_08"], EHDI.Assets.images["rotate_tablet_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_tablet_01"], EHDI.Assets.images["rotate_tablet_08"], EHDI.Assets.images["rotate_tablet_07"], EHDI.Assets.images["rotate_tablet_06"], EHDI.Assets.images["rotate_tablet_05"]], [EHDI.Assets.images["rotate_tablet_05"], EHDI.Assets.images["rotate_tablet_04"], EHDI.Assets.images["rotate_tablet_03"], EHDI.Assets.images["rotate_tablet_02"], EHDI.Assets.images["rotate_tablet_01"]]],
        armatureOffsetX : -0.02,
        armatureOffsetY : 0.17,
        values: [
            {x : 1, y : 0, z : 0},
            {x : 1, y : 0, z : 1},
            {x : 1, y : 0, z : 2},
            {x : 1, y : 0, z : 3},
            {x : 1, y : 0, z : 4},
            {x : 2, y : 0, z : 0},
            {x : 2, y : 0, z : 1},
            {x : 2, y : 0, z : 2},
            {x : 2, y : 0, z : 3},
            {x : 2, y : 0, z : 4},
            {x : 3, y : 0, z : 0},
            {x : 3, y : 0, z : 1},
            {x : 3, y : 0, z : 2},
            {x : 3, y : 0, z : 3},
            {x : 3, y : 0, z : 4},
            {x : 1, y : 1, z : 0},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 1, y : 1, z : 4},
            {x : 2, y : 1, z : 0},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 2, y : 1, z : 4},
            {x : 3, y : 1, z : 0},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 3, y : 1, z : 4},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 1, y : 2, z : 4},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 2, y : 2, z : 4},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 3, y : 2, z : 4},
            {x : 1, y : 3, z : 1},
            {x : 1, y : 3, z : 2},
            {x : 1, y : 3, z : 3},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 2},
            {x : 3, y : 3, z : 3}
        ]
    }
    
    var heart = {
        width : 5,
        height : 4,
        armatureName : "rotate_heart",
        ccwArr : [[EHDI.Assets.images["rotate_heart_01"], EHDI.Assets.images["rotate_heart_02"], EHDI.Assets.images["rotate_heart_03"], EHDI.Assets.images["rotate_heart_04"], EHDI.Assets.images["rotate_heart_05"]], [EHDI.Assets.images["rotate_heart_05"], EHDI.Assets.images["rotate_heart_06"], EHDI.Assets.images["rotate_heart_07"], EHDI.Assets.images["rotate_heart_08"], EHDI.Assets.images["rotate_heart_01"]]],
        cwArr : [[EHDI.Assets.images["rotate_heart_01"], EHDI.Assets.images["rotate_heart_08"], EHDI.Assets.images["rotate_heart_07"], EHDI.Assets.images["rotate_heart_06"], EHDI.Assets.images["rotate_heart_05"]], [EHDI.Assets.images["rotate_heart_05"], EHDI.Assets.images["rotate_heart_04"], EHDI.Assets.images["rotate_heart_03"], EHDI.Assets.images["rotate_heart_02"], EHDI.Assets.images["rotate_heart_01"]]],
        armatureOffsetX : 0,
        armatureOffsetY : 0.27,
        values: [
            {x : 1, y : 0, z : 2},
            {x : 2, y : 0, z : 2},
            {x : 3, y : 0, z : 2},
            {x : 1, y : 1, z : 1},
            {x : 1, y : 1, z : 2},
            {x : 1, y : 1, z : 3},
            {x : 2, y : 1, z : 1},
            {x : 2, y : 1, z : 2},
            {x : 2, y : 1, z : 3},
            {x : 3, y : 1, z : 1},
            {x : 3, y : 1, z : 2},
            {x : 3, y : 1, z : 3},
            {x : 1, y : 2, z : 0},
            {x : 1, y : 2, z : 1},
            {x : 1, y : 2, z : 2},
            {x : 1, y : 2, z : 3},
            {x : 1, y : 2, z : 4},
            {x : 2, y : 2, z : 0},
            {x : 2, y : 2, z : 1},
            {x : 2, y : 2, z : 2},
            {x : 2, y : 2, z : 3},
            {x : 2, y : 2, z : 4},
            {x : 3, y : 2, z : 0},
            {x : 3, y : 2, z : 1},
            {x : 3, y : 2, z : 2},
            {x : 3, y : 2, z : 3},
            {x : 3, y : 2, z : 4},
            {x : 1, y : 3, z : 0},
            {x : 1, y : 3, z : 1},
            {x : 1, y : 3, z : 3},
            {x : 1, y : 3, z : 4},
            {x : 2, y : 3, z : 0},
            {x : 2, y : 3, z : 1},
            {x : 2, y : 3, z : 2},
            {x : 2, y : 3, z : 3},
            {x : 2, y : 3, z : 4},
            {x : 3, y : 3, z : 0},
            {x : 3, y : 3, z : 1},
            {x : 3, y : 3, z : 3},
            {x : 3, y : 3, z : 4}
        ]
    }
    
    
    var shapeRandomizer = [smallCube, largeCube, heart, house, cross, pyramid];

    return shapeRandomizer[Math.floor(EHDI.NumberUtil.randomRange(0, shapeRandomizer.length))];
    
    
}